export default __webpack_public_path__ + "static/media/img-slider-siamblockchain-6.4e2a6980.png";